
let scrollPrev = 0;

document.addEventListener("DOMContentLoaded",function(){
    const loaderContainer = document.querySelector('.loader-container');
    setTimeout(() => {
      loaderContainer.classList.add('loader-container--hidden');
    }, 500);
    eventListeners();
});

function eventListeners() {

  const btn_menu = document.querySelector("#btn_menu");
  btn_menu.addEventListener("click", mostrarMenu);

  const background_menu = document.querySelector("#back_menu");
  background_menu.addEventListener("click",mostrarMenu);

  const btn_cerrar = document.querySelector("#btn_cerrar");
  btn_cerrar.addEventListener("click",mostrarMenu);

  const metodoContacto = document.querySelectorAll("input[name='contacto[contacto]']");

  metodoContacto.forEach(input => input.addEventListener("click",mostrarMetodoContacto));

  window.addEventListener("scroll", ocultarHeader);

  /* DROPDOWN FUNCTION */
  const dropdowns = document.querySelectorAll(".dropdown");
  dropdowns.forEach(mostrarDropdowns);
  /* DROPDOWN FUNCTION  FIN*/
}


/* FUNCION MOSTRAR/OCULTAR DROPDOWNS */
function mostrarDropdowns(dropdown) {
  const select = dropdown.querySelector(".select");
  const caret = dropdown.querySelector(".caret");
  const dd_menu = dropdown.querySelector(".dd_menu");
  const options = dropdown.querySelectorAll(".dd_menu li");
  const selected = dropdown.querySelector(".selected");

  caret.addEventListener("click", () => {
    select.classList.toggle("select-clicked");
    caret.classList.toggle("caret-rotate");
    dd_menu.classList.toggle("dd_menu-open");
  });

  options.forEach(option => {
    option.addEventListener("click", () => {

        caret.classList.toggle("caret-rotate");

        dd_menu.classList.remove("dd_menu-open");

        options.forEach(option => {
            option.classList.remove("active");
        });

        option.classList.add("active");
    });
  });
}


$('#formContacto').on("submit", (e) => {

  
  e.preventDefault();
  var formData = $("#formContacto").serialize();

  $.easyAjax({
    url: '/enviarFormContacto',
    type: "POST",
    dataType: "text",
    data: {rpt: formData},
    success: function (response) {
        console.log(response, 'exito');
        $("#alertaContacto").html(response);
        $("form select").each(function() { this.selectedIndex = 0 });
        $("form input[type=radio]").each(function() { this.checked = false });
        $("form input[type=text], form textarea").each(function() { this.value = '' });
    },
    error: function (error) {
        console.log(error, 'error');
    },
  });

});


// FUNCION OCULTAR ALERTAS
function ocultarAlerta() {
  $(".alerta").hide("slow");
}

// function ajax
function enviarDatos(id) {

  $.easyAjax({
    url: '/verPintura?id='+id,
    data: {id: id},
    dataType: "text",
    success: function (response) {
        // console.log(response);
        $(".modal").html(response);
    },
    error: function (error) {
        console.log(error, 'error');
    },
  });
}
// FIN DE FUNCION AJAX

function quitarModal() {
    const modal = document.querySelector(".modal");
    modal.innerHTML = '';
}


function ocultarHeader() {
  const body = document.querySelector("body");
  
  const winTop = window.scrollY;
  
  const header = document.querySelector(".header");

  if (winTop >= 30) {
    body.classList.add("sticky");

    if (winTop > scrollPrev || window.innerWidth > 1024) {
      header.classList.add("ocultar");

    } else {
      header.classList.remove("ocultar");
    }
    scrollPrev = winTop;
    // console.log(scrollPrev)
  } else {
    body.classList.remove("sticky");
  }
}

function mostrarMenu() {
    const menu = document.querySelector(".menu");
    const background_menu = document.querySelector("#back_menu");
    const body = document.querySelector("body");

    body.classList.toggle("no-scroll");
    menu.classList.toggle("mostrar");
    background_menu.classList.toggle("mostrar");
}


function mostrarMetodoContacto (e) {
    const medio = document.querySelector("#contacto");

    if(e.srcElement.value === "telefono") {
        medio.innerHTML = `

            <label for="telefono"> No. Teléfono</label>
            <input type="tel" placeholder="Tu Teléfono" id="telefono" name="contacto[telefono]" >

            <p>Elija la fecha y hora</p>
            <label for="fecha">Fecha</label>
            <input type="date"  id="fecha" name="contacto[fecha]" required>

            <label for="hora">Hora</label>
            <input type="time" id="hora" min="09:00" max="18:00" name="contacto[hora]" required>

        `
    } else {
        medio.innerHTML = `
            <label for="email">Digite su e-mail</label>
            <input type="email" placeholder="Tu Correo" id="email" name="contacto[email]" required >
        `
    }

}



